import { render, staticRenderFns } from "./OnboardingTour.vue?vue&type=template&id=0655ee28&scoped=true"
import script from "./OnboardingTour.vue?vue&type=script&lang=js"
export * from "./OnboardingTour.vue?vue&type=script&lang=js"
import style0 from "./OnboardingTour.vue?vue&type=style&index=0&id=0655ee28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655ee28",
  null
  
)

export default component.exports